<template>
  <div class="share-list-container">
    <div class="header-box">
      <p>分享列表</p>
    </div>
    <div class="operation-box">
      <div class="common-button-box">
        <el-button
          class="normal-btn"
          v-if="isChecked('Project.Single.Share.Cancel')"
          size="mini"
          @click="batchCancelShare"
          >批量移除</el-button
        >
      </div>
      <div class="filter-box">
        <div class="cascader-box">
          <span class="label-box searchLabel gr16">资源类型</span>
          <div class="common-select-box">
            <el-cascader
              v-if="showCascader"
              :append-to-body="false"
              popper-class="common-cascader-box"
              class="primary-select"
              size="small"
              v-model="resourceType"
              :options="resourceOptions"
              @change="handleCascaderChange"
              @visible-change="visibleChange"></el-cascader>
          </div>
        </div>
        <div class="common-input-box">
          <el-input
            class="search-input input-primary"
            size="small"
            v-model="keywords"
            placeholder="请输入资源名称"
            clearable
            @clear="search"
            @keyup.enter.native="search">
            <i
              slot="suffix"
              class="el-input__icon el-icon-search"
              @click="search" />
          </el-input>
        </div>
      </div>
    </div>
    <div class="common-table-box">
      <el-table
        :header-row-class-name="customHeader"
        ref="modelTable"
        highlight-selection-row
        class="publish-table"
        :data="shareList"
        height="100%"
        @select="selectChange"
        @select-all="selectChange">
        <el-table-column
          type="selection"
          width="60">
        </el-table-column>
        <el-table-column
          label="序号"
          type="index"
          width="55"></el-table-column>
        <el-table-column
          label="资源名称"
          width="360">
          <template v-slot="{ row }">
            <span
              :class="`text-overflow ${
                row.isValidShare ? 'link-style' : 'disabled-style'
              }`"
              :title="row.resourceName"
              @click="modelView(row)"
              >{{ row.resourceName }}</span
            >
          </template>
        </el-table-column>
        <el-table-column
          label="分享者"
          width="200">
          <template v-slot="{ row }">
            <span>{{ row.shareFromUserName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="分享时间"
          width="270">
          <template v-slot="{ row }">
            <span>{{ formatTime(row.limitedTimeBegin) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="到期时间"
          width="270">
          <template v-slot="{ row }">
            <div class="limited-timeend-box">
              <div :class="`circle ${row.limitedTimeEndClass}-bg`"></div>
              <span :class="`${row.limitedTimeEndClass}`">
                {{ row.limitedTimeEnd }}</span
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column label="资源类型">
          <template v-slot="{ row }">
            <span>{{ formatResourceType(row) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="所属项目">
          <template v-slot="{ row }">
            <span>{{ row.projName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="80">
          <template v-slot="{ row }">
            <div class="operation-cell">
              <el-button
                size="small"
                type="text"
                @click="cancelShareById(row)"
                >移除</el-button
              >
            </div>
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="common-empty-box">
            <bj-empty
              :image="require('@/assets/img/no-data.png')"
              class="empty-page">
              <template slot="description">
                <div class="empty-text">抱歉，没有找到相关内容</div>
              </template>
            </bj-empty>
          </div>
        </template>
      </el-table>
    </div>
    <div class="common-pagination-box pagination-primary">
      <el-pagination
        popper-class="common-pagination-popper-box"
        layout="sizes, prev, pager, next, jumper"
        :page-sizes="[10, 20, 50, 100, 150, 200]"
        :page-size="pageSize"
        :current-page="currentPage"
        :total="total"
        @size-change="sizeChange"
        @current-change="pageChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { Store } from '@/utils/store'
import { formatTime } from '@/utils/generalMethods'

import {
  qureyShareToMeListService,
  removeOtherShareService,
  generateUser
} from '@/service/interface'

export default {
  data() {
    return {
      keywords: '',
      resourceType: ['all'],
      resourceOptions: [
        { value: 'all', label: '所有' },
        {
          value: 'dataSet',
          label: '数据集',
          children: [
            { value: 'all', label: '全部' },
            { value: 1, label: '模型' },
            { value: 2, label: '模型组' },
            { value: 3, label: '遥感影像' },
            { value: 4, label: 'Wmts' },
            { value: 5, label: '倾斜摄影' },
            { value: 6, label: '360全景图' },
            { value: 7, label: '点云' },
            { value: 8, label: '二维图纸' },
            { value: 9, label: '矢量' }
          ]
        },
        { value: 0, label: '场景' }
      ],

      shareList: [],
      pageSize: 10,
      currentPage: 1,
      total: 0,
      selectShares: [],
      timer: null,
      customHeader: '',
      showCascader: true
    }
  },
  mounted() {
    this.$nextTick(() => {
      const currentBody = this.$refs.modelTable?.bodyWrapper
      currentBody &&
        currentBody.addEventListener('scroll', ev => {
          const scrollTop = ev.target.scrollTop
          this.customHeader = scrollTop > 10 ? 'darkHeader' : ''
        })
    })
    this.qureyShareList()
    this.timer = setInterval(this.qureyShareList, 1 * 60 * 1000)
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  },
  methods: {
    qureyShareList() {
      let filter = this.getResourceTypeFilter()

      let params = {
        resourceName: this.keywords,
        resourceSubType: filter.resourceSubType,
        resourceType: filter.resourceType,
        skipCount: (this.currentPage - 1) * this.pageSize,
        resultCount: this.pageSize,
        showProjectName: true
      }
      qureyShareToMeListService(params).then(response => {
        if (response.isSuccess) {
          let data = response.data
          this.shareList = this.formatShareList(data.items)
          this.total = data.totalCount
        }
      })
    },
    handleCascaderChange() {
      this.keywords = ''
      this.currentPage = 1
      this.pageSize = 10
      this.qureyShareList()
    },
    visibleChange(flag) {
      if (flag) return
      this.showCascader = false
      this.$nextTick(() => {
        this.showCascader = true
      })
    },
    search() {
      this.currentPage = 1
      this.qureyShareList()
    },
    pageChange(currentPage) {
      this.currentPage = currentPage
      this.qureyShareList()
    },
    sizeChange(pageSize) {
      this.pageSize = pageSize
      this.currentPage = 1
      this.qureyShareList()
    },
    selectChange(selection) {
      this.selectShares = selection
    },
    cancelShareById(shareInfo) {
      let params = {
        shareIds: [shareInfo.shareId]
      }
      removeOtherShareService(params).then(response => {
        if (response.isSuccess) {
          this.$message.success('取消分享成功！！！')
          this.selectScenes = []
          this.qureyShareList()
        } else {
          this.$message.error(response.errMsg)
        }
      })
    },
    batchCancelShare() {
      if (!this.selectShares.length) {
        this.$message.warning('请先选择需要取消分享的资源！')
        return
      }
      let shareIds = this.selectShares.map(el => el.shareId)
      let params = { shareIds }
      removeOtherShareService(params).then(response => {
        if (response.isSuccess) {
          this.$message.success('取消分享成功！！！')
          this.selectScenes = []
          this.qureyShareList()
        } else {
          this.$message.error(response.errMsg)
        }
      })
    },
    formatShareList(shareList) {
      shareList = shareList.map(item => {
        let obj = {
          shareType: item.shareType,
          shareId: item.shareId,
          resourceId: item.resourceId,
          resourceName: item.resourceName,
          shareFromUserName: item.shareFromUserName,
          isValidShare: this.isValidShare(item),
          limitedTimeBegin: item.limitedTimeBegin,
          limitedTimeEnd: this.getLimitedTimeEnd(item),
          limitedTimeEndClass: this.getLimitedTimeEndClass(item),
          resourceType: item.resourceType,
          resourceSubType: item.resourceSubType,
          displayMode: item.displayMode,
          projName: item.projName,
          shareToToken: item.shareToToken
        }
        return obj
      })
      return shareList
    },
    getResourceTypeFilter() {
      let resourceType = undefined
      let resourceSubType = undefined
      if (this.resourceType.length === 1) {
        if (this.resourceType[0] === 0) {
          resourceType = 0
        }
      }
      if (this.resourceType.length === 2) {
        let subType = this.resourceType[1]
        if (subType === 'all') {
          resourceType = 2
        } else {
          resourceType = 2
          resourceSubType = subType
        }
      }
      return { resourceType, resourceSubType }
    },
    modelView(resourceInfo) {
      if (!resourceInfo.isValidShare) return

      let pageUrl = ''
      let resourceType = resourceInfo.resourceType
      if (resourceType === 0) {
        pageUrl = 'sceneShare/view'
      } else {
        pageUrl = 'dataSetShare/view'
      }
      let shareType = resourceInfo.shareType
      if (shareType === 2) {
        let url = ''
        if (resourceType === 0) {
          url = `${window.location.origin}${window.location.pathname}#/${pageUrl}/${resourceInfo.shareId}/${resourceInfo.resourceId}?viewMode=${resourceInfo.displayMode}&token=${resourceInfo.shareToToken}`
        } else {
          let dataType = this.getDataType(resourceInfo.resourceSubType)
          url = `${window.location.origin}${window.location.pathname}#/${pageUrl}/${resourceInfo.shareId}/${resourceInfo.resourceId}?dataType=${dataType}&token=${resourceInfo.shareToToken}`
        }

        window.open(url, '_blank')
      } else {
        let userInfo = Store.userInfo
        let params = {
          userId: userInfo.userId,
          sceneId: resourceInfo.resourceId
        }
        generateUser(params).then(response => {
          if (response.isSuccess) {
            let data = response.data
            if (data) {
              let url = ''
              if (resourceType === 0) {
                url = `${window.location.origin}${window.location.pathname}#/${pageUrl}/${resourceInfo.shareId}/${resourceInfo.resourceId}?viewMode=${resourceInfo.displayMode}&token=${resourceInfo.shareToToken}`
              } else {
                let dataType = this.getDataType(resourceInfo.resourceSubType)
                url = `${window.location.origin}${window.location.pathname}#/${pageUrl}/${resourceInfo.shareId}/${resourceInfo.resourceId}?dataType=${dataType}&token=${resourceInfo.shareToToken}`
              }

              window.open(url, '_blank')
            }
          }
        })
      }
    },
    getLimitedTimeEnd(item) {
      let limitedTime = item.limitedTime

      let currentTime = new Date().getTime()
      let endTime = new Date(Date.parse(item.limitedTimeEnd)).getTime()

      if (limitedTime === 4) {
        return '永久有效'
      }

      if (currentTime - endTime > 0) {
        return '已过期'
      }

      return this.formatTime(item.limitedTimeEnd)
    },
    getLimitedTimeEndClass(item) {
      let limitedTime = item.limitedTime

      let currentTime = new Date().getTime()
      let endTime = new Date(Date.parse(item.limitedTimeEnd)).getTime()

      if (limitedTime === 4) {
        return 'forever'
      }

      if (currentTime - endTime > 0) {
        return 'overtime'
      }

      return 'normal'
    },
    getDataType(resourceSubType) {
      let dataTypeArray = [
        { value: 1, label: 'Bim' },
        { value: 2, label: 'Bim' },
        { value: 3, label: 'Rs' },
        { value: 4, label: 'Wmts' },
        { value: 5, label: 'Osgb' },
        { value: 6, label: 'Panorama' },
        { value: 7, label: 'PointCloud' },
        { value: 8, label: 'Cad' },
        { value: 9, label: 'Vector' }
      ]
      let find = dataTypeArray.find(el => el.value === resourceSubType)
      return find.label
    },
    formatResourceType(shareInfo) {
      const dataTypeMap = [
        '场景',
        '模型',
        '模型组',
        '遥感影像',
        'WMTS地图服务',
        '倾斜摄影',
        '360全景图',
        '点云',
        '二维图纸',
        '矢量'
      ]

      let { resourceType, resourceSubType } = shareInfo
      if (resourceType === 0) {
        return dataTypeMap[0]
      } else {
        return dataTypeMap[resourceSubType]
      }
    },
    /**
     * 分享是否过期
     */
    isValidShare(share) {
      let limitedTime = share.limitedTime

      let currentTime = new Date().getTime()
      let endTime = new Date(Date.parse(share.limitedTimeEnd)).getTime()

      if (limitedTime === 4) {
        return true
      }

      if (currentTime - endTime > 0) {
        return false
      }

      return true
    },
    /**
     * 权限验证
     */
    isChecked(permissionCode) {
      let permissionData = Store.permissionData
      let find = permissionData.find(el => el.permissionCode === permissionCode)
      return find.isCheck
    },
    formatTime
  }
}
</script>

<style lang="less" scoped>
@import url('@/assets/css/publishSearch.less');
@import url('@/assets/css/pageStyle.less');
.share-list-container {
  position: relative;
  height: 100%;
  padding: 16px;
  border-radius: 5px;
  background: var(--page-bgColor);

  .header-box {
    height: 20px;
    text-align: left;
    border-left: 4px solid var(--base-primary-color);

    p {
      line-height: 20px;
      margin-left: 10px;
      color: var(--share-page-title);
    }
  }

  .operation-box {
    display: flex;
    justify-content: space-between;
    margin: 16px 0px;

    .common-button-box {
      margin: auto 0px;
      // .el-button--default {
      //   height: unset;
      // }
    }

    .filter-box {
      display: flex;
      .cascader-box {
        display: flex;
        .label-box {
          line-height: 32px;
        }
      }

      .common-input-box {
        margin-left: 10px;
      }
    }
  }

  .common-table-box {
    height: calc(100% - 132px);

    .link-style {
      cursor: pointer;
      &:hover {
        color: var(--base-primary-bgColor);
        text-decoration: underline;
      }
    }

    .disabled-style {
      cursor: not-allowed;
      color: var(--disabled-text-color);
    }

    .limited-timeend-box {
      display: flex;
      .circle {
        width: 5px;
        height: 5px;
        margin: auto 10px auto 0px;
        border-radius: 50%;
      }

      .normal {
        color: var(--runing-status-color);
      }

      .normal-bg {
        background-color: var(--runing-status-color);
      }

      .overtime {
        color: var(--error-status-color);
      }

      .overtime-bg {
        background-color: var(--error-status-color);
      }

      .forever {
        color: var(--success-status-color);
      }

      .forever-bg {
        background-color: var(--success-status-color);
      }
    }
  }

  .common-pagination-box {
    position: absolute;
    width: 100%;
    padding-right: 20px;
  }
}
</style>
